import { ChangeEvent, useCallback } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { TextField, TextFieldProps } from '@material-ui/core';

import { FormFieldProps, useFormField } from '../../context';

export type DescriptionFormFieldProps = Omit<TextFieldProps, 'value'> &
  FormFieldProps<string> & {
    loading?: boolean;
  };

export const DescriptionFormField = ({
  field = 'description',
  initialValue = '',
  onChange,
  loading,
  ...props
}: DescriptionFormFieldProps) => {
  const { value, setValue } = useFormField(field, initialValue);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setValue(e.target.value);
      onChange?.(e);
    },
    [onChange, setValue],
  );

  return (
    <TextField
      fullWidth
      multiline
      minRows={4}
      maxRows={4}
      value={value ?? ''}
      onChange={handleChange}
      label="Description"
      name="variant-description"
      margin="dense"
      variant="outlined"
      InputLabelProps={{ shrink: true, ...props.InputLabelProps }}
      placeholder="Add a short description of the treatment"
      disabled={loading}
      {...props}
    />
  );
};
